// AuthService.ts
import {
  RequestOtpRequest,
  VerifyOtpRequest,
} from "@/central-atoms/everest-fleet-pwa/requests";
import {
  DriverDetailsResponse,
  FleetConfigurationResponse,
  RequestOtpResponse,
  SupervisorDetailsResponse,
  VerifyOtpResponse,
} from "@/central-atoms/everest-fleet-pwa/responses";
import { apiClient, unauthenticatedApiClient } from "../apiClient";
import { OPERATOR_CODE } from "@/constants";

class AuthService {
  static async request_otp(
    credentials: RequestOtpRequest
  ): Promise<RequestOtpResponse> {
    const response = await unauthenticatedApiClient.post(
      `/request_sms_otp`,
      credentials
    );
    return response.data;
  }

  static async verify_otp(
    credentials: VerifyOtpRequest
  ): Promise<VerifyOtpResponse> {
    const response = await unauthenticatedApiClient.post(
      `/verify_sms_otp`,
      credentials
    );
    return response.data;
  }

  static async getFleetConfiguration(
    operatorCode: string
  ): Promise<FleetConfigurationResponse> {
    const response = await unauthenticatedApiClient.get(
      `/configuration_via_operator_code`,
      {
        params: { operator_code: operatorCode },
      }
    );
    return response.data;
  }

  static async getDriverDetails(): Promise<DriverDetailsResponse> {

    const response = await apiClient.get(`/driver_details`, {
      params: {
        operator_code: OPERATOR_CODE
      }
    });
    return response.data.data;
  }

  static async getSupervisorDetails(): Promise<SupervisorDetailsResponse> {
    const response = await apiClient.get(`/supervisor_details`, {
      params: {
        operator_code: OPERATOR_CODE
      }
    });
    return response.data.data;
  }
}

export default AuthService;
